import { Pipe, PipeTransform } from '@angular/core';
import { Customer } from '../../classes/customer';

function customerEmailText(customer: Customer): string {
    return (customer.emails || [])
        .map(row => (row?.Email || '').trim())
        .filter(email => email.length > 0)
        .join(' ');
}

@Pipe({
    name: 'customerEmailFilter',
    pure: false
})
export class CustomerEmailFilterPipe implements PipeTransform {

    transform(customerList: Array<Customer>, filterValue: string): any {
        if (!customerList || !filterValue) {
            return customerList;
        }
        const normalizedFilter = filterValue.toLowerCase().trim();
        return customerList.filter(customer =>
            customerEmailText(customer).toLowerCase().indexOf(normalizedFilter) !== -1
            || (customer.PEC || '').toLowerCase().indexOf(normalizedFilter) !== -1
        );
    }

}
